export const FETCH_DATA_MAX_VALUE = 'FETCH_DATA_MAX_VALUE';
export const SET_PROGRESSBAR_LABEL = 'SET_PROGRESSBAR_LABEL';
export const ASSIGN_DATA_MAX_VALUE = 'ASSIGN_DATA_MAX_VALUE';
export const FETCH_DATA_VALUE = 'FETCH_DATA_VALUE';
export const ASSIGN_DATA_VALUE = 'ASSIGN_DATA_VALUE';

const initialState = {
  progressBar: {
    fetch: {
      title: 'Fetching Lead Records',
      progress: 0,
      maxValue: 50000,
      show: false
    },
    assign: {
      title: 'Assigning Lead Records',
      progress: 0,
      maxValue: 10000,
      show: false
    }
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_FETCH_PROGRESS_BAR':
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          fetch: {
            title: 'Fetching Lead Records',
            progress: 0,
            maxValue: 50000,
            show: false
          }
        }
      };
    case 'RESET_ASSIGN_PROGRESS_BAR':
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          assign: {
            title: 'Assigning Lead Records',
            progress: 0,
            maxValue: 10000,
            show: false
          }
        }
      };
    case 'FETCH_DATA_VALUE':
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          fetch: {
            ...state.progressBar.fetch,
            progress: action.payload,
            show: !(state.progressBar.fetch.maxValue === action.payload ||
              (state.progressBar.fetch.maxValue) === action.payload)
          }
        }
      };
    case 'ASSIGN_DATA_VALUE':
      if (__TRAINING__) {
        return {
          ...state,
          progressBar: {
            ...state.progressBar,
            assign: {
              ...state.progressBar.assign,
              progress: 100,
              show: false
            }
          }
        };
      }
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          assign: {
            ...state.progressBar.assign,
            progress: action.payload ? action.payload : state.progressBar.assign.progress + 1,
            show: !(state.progressBar.assign.maxValue <= (action.payload ?
              action.payload : state.progressBar.assign.progress + 1))
          }
        }
      };
    case SET_PROGRESSBAR_LABEL:
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          fetch: {
            ...state.progressBar.fetch,
            title: action.payload,
          }
        }
      };
    case 'FETCH_DATA_MAX_VALUE':
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          fetch: {
            ...state.progressBar.fetch,
            maxValue: action.payload,
            show: true
          }
        }
      };
    case 'ASSIGN_DATA_MAX_VALUE':
      return {
        ...state,
        progressBar: {
          ...state.progressBar,
          assign: {
            ...state.progressBar.assign,
            maxValue: state.progressBar.assign.show ?
            action.payload + state.progressBar.assign.maxValue : action.payload,
            show: true
          }
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/app.js